<ul aria-labelledby="tag-group" [class]="'c-cjm-tag-group' + ' ' + classes">
	<ng-content></ng-content>
</ul>
